import { render, staticRenderFns } from "./FormBuilderV2.vue?vue&type=template&id=537dead2&scoped=true&"
import script from "./FormBuilderV2.vue?vue&type=script&lang=js&"
export * from "./FormBuilderV2.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderV2.vue?vue&type=style&index=0&id=537dead2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537dead2",
  null
  
)

export default component.exports